
import { Vue, Component, Prop, Emit } from 'vue-property-decorator';
import PreQuestionField from '@/components/PreQuestionField.vue';
import AppButton from '@/components/AppButton.vue';
import { MutationType } from '@/enums';
import { PreQuestion } from '@/types';

@Component({
	components: {
		PreQuestionField,
		AppButton
	}
})
export default class PreQuestionSurvey extends Vue {
	private get title(): string {
		return this.$store.state.preQuestionList.subTitle;
	}

	private get questions(): PreQuestion[] {
		return this.$store.state.preQuestionList.questions;
	}

	private savePreQuestionAnswers(): void{
		this.$store.commit(MutationType.SAVE_PRE_QUESTIONS);
	}

	@Emit()
	private finish(): void {
		this.$store.commit(MutationType.FINISH_PRE_QUESTIONS);
	}
}
